import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { QueryClient, QueryCache, MutationCache } from "@tanstack/vue-query";
import { ZodError } from "zod";
const queryCache = new QueryCache({
    onError: (error, query) => {
        if (error instanceof ZodError) {
            // 쿼리 키에서 엔드포인트 정보 추출
            const queryKey = query.queryKey;
            const endpoint = Array.isArray(queryKey) ? queryKey[0] : queryKey;
            console.warn("🫵🫵🫵 Zod 스키마 검증 실패:", error.issues);
            console.warn("📍 엔드포인트:", endpoint);
            // 에러 메시지에 엔드포인트 정보 포함
            const errorMessage = `✏️ 에러 내용: ${error.issues[0].message}\n🔨 위치: ${String(error.issues[0].path[1])}\n📍 엔드포인트: ${endpoint}`;
            showAlert(errorMessage, "Zod 스키마 검증 실패");
        }
    },
});
const mutationCache = new MutationCache({
    onError: (error, _variables, _context, mutation) => {
        // mutation-level onError가 없는 경우에만 전역 알림
        if (!mutation.options.onError) {
            showAlert(getErrorMessage(error), "요청 실패");
        }
    },
});
export const queryClient = new QueryClient({
    queryCache,
    mutationCache,
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60,
            refetchOnMount: false,
            retry: false,
        },
    },
});
window.__TANSTACK_QUERY_CLIENT__ = queryClient;
